import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue, useEffect } from "react";
import isFunction from "lodash/isFunction";
import Cookies from "js-cookie";
import useUpdate from "./useUpdate";
import usePersist from "./usePersist";
import useInterval from "./useInterval";
import useSafeState from "./useSafeState";
function useCookie(name, options) {
  var _ref = options || {},
    defaultValue = _ref.defaultValue,
    _ref$polling = _ref.polling,
    polling = _ref$polling === void 0 ? false : _ref$polling,
    _ref$pollingInterval = _ref.pollingInterval,
    pollingInterval = _ref$pollingInterval === void 0 ? 100 : _ref$pollingInterval,
    validate = _ref.validate;
  function getCookie() {
    var cookie = Cookies.get(name);
    if (cookie !== undefined) {
      if (validate) {
        return validate(cookie) ? cookie : defaultValue;
      } else {
        return cookie;
      }
    } else {
      return defaultValue;
    }
  }
  var _useSafeState = useSafeState(getCookie),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    value = _useSafeState2[0],
    setValue = _useSafeState2[1];
  var setCookie = usePersist(function (newValue, attributes) {
    setValue(function (prevValue) {
      newValue = isFunction(newValue) ? newValue(prevValue) : newValue;
      if (newValue === undefined) {
        Cookies.remove(name, attributes);
        return defaultValue;
      } else {
        Cookies.set(name, newValue, attributes);
        return newValue;
      }
    });
  });
  var _useInterval = useInterval(function () {
      var newValue = getCookie();
      if (newValue !== value) {
        setValue(newValue);
      }
    }, pollingInterval),
    _useInterval2 = _slicedToArray(_useInterval, 2),
    startPolling = _useInterval2[0],
    cancelPolling = _useInterval2[1];
  useEffect(function () {
    cancelPolling();
    if (polling) {
      startPolling();
    }
  }, [polling] // eslint-disable-line
  );

  useUpdate(function () {
    cancelPolling();
    setValue(getCookie());
    if (polling) {
      startPolling();
    }
  }, [name]);
  useUpdate(function () {
    if (Cookies.get(name) === undefined && defaultValue !== value) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  useDebugValue(value);
  useDebugValue(name, function (name) {
    return "(raw) " + Cookies.get(name);
  });
  return [value, setCookie];
}
export default useCookie;